import Swiper from 'swiper'

const gallerySwiper = new Swiper('.js-gallery-slider', {
  slidesPerView: 'auto',
  spaceBetween: 20,
  navigation: {
    nextEl: '.js_gallery-next',
    prevEl: '.js_gallery-prev'
  }
})



// WEBPACK FOOTER //
// ./src/js/components/slider.js